import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "../../../../../components";
import "./EmailInvoiceModal.scss";

class EmailInvoiceModal extends Component {
	constructor(props) {
		super(props);

		this.initialState = {
			userEmail: "",
			additionalEmails: [],
			hasError: false,
		};

		this.state = { ...this.initialState };
	}

	/** Adds additional inputs which lets the user add additional contacts */
	addEmail = submitEmail => {
		const { billingEmail } = this.props;
		this.setState(
			prevState => {
				if (
					/\S+@\S+\.\S{2,}$/.test(prevState.userEmail) &&
					!prevState.additionalEmails.includes(prevState.userEmail) &&
					prevState.userEmail !== billingEmail
				) {
					return {
						userEmail: "",
						additionalEmails: [...prevState.additionalEmails, prevState.userEmail],
					};
				}

				if (!prevState.userEmail) {
					return {
						userEmail: "",
						additionalEmails: [...prevState.additionalEmails],
					};
				}

				return { hasError: true };
			},
			() => this.sendEmail(submitEmail),
		);
	};

	sendEmail = (submitEmail = false) => {
		const { additionalEmails, hasError } = this.state;
		const { onSubmit } = this.props;

		if (submitEmail && !hasError) {
			onSubmit([...additionalEmails]);
		}
	};

	removeAdditionalEmail = email => {
		this.setState(prevState => ({
			additionalEmails: prevState.additionalEmails.filter(item => item !== email),
		}));
	};

	render() {
		const { lang } = global;
		const { userEmail, additionalEmails, hasError } = this.state;
		const { show, title, message, confirmButtonText, loading, onCancel } = this.props;

		return (
			<Modal
				id="email-invoice-modal"
				show={show}
				onHide={onCancel}
				onExited={() => this.setState(this.initialState)}
			>
				<Modal.Header closeButton>
					<Modal.Title>{title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Choose>
						<When condition={typeof message === "object"}>
							{message}
							<br />
						</When>
						<Otherwise>
							<div>{message}</div>
							<br />
						</Otherwise>
					</Choose>
					<label htmlFor="userEmail">{`${lang.t("Need to send to additional people_")} ${lang.t("Add emails below separated by a comma_")}`}</label>
					<div className="row form-group">
						<div className="col-xs-12">
							<input
								type="email"
								id="userEmail"
								name="userEmail"
								className={`form-control ${hasError ? "invalid-field" : ""}`}
								value={userEmail}
								placeholder="Email"
								onChange={e =>
									this.setState({
										userEmail: e.target.value.replace(",", ""),
										hasError: false,
									})
								}
								onKeyPress={({ key }) => {
									if (key === "Enter") this.addEmail();
								}}
								onKeyUp={({ key }) => {
									if (key === ",") this.addEmail();
								}}
							/>
						</div>
					</div>
					<For
						each="email"
						of={additionalEmails}
					>
						<button
							key={`bcc-${email}`}
							type="button"
							className="btn btn-rounded"
							onClick={() => this.removeAdditionalEmail(email)}
						>
							{email}
							&nbsp;
							<span className="badge">X</span>
						</button>
					</For>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						className="btn btn-link"
						onClick={onCancel}
					>
						{lang.t("Cancel")}
					</button>
					<button
						type="button"
						className="btn btn-primary"
						onClick={() => this.addEmail(true)}
						disabled={loading}
					>
						<Choose>
							<When condition={loading}>
								<i className="glyphicon glyphicon-repeat rkf-spin rkf-fw" />
							</When>
							<Otherwise>{confirmButtonText}</Otherwise>
						</Choose>
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}

EmailInvoiceModal.propTypes = {
	show: PropTypes.bool,
	title: PropTypes.string,
	message: PropTypes.any,
	confirmButtonText: PropTypes.string,
	loading: PropTypes.bool,
	onCancel: PropTypes.func,
	onSubmit: PropTypes.func,
	billingEmail: PropTypes.string,
};

EmailInvoiceModal.defaultProps = {
	show: false,
	title: "E-mail Invoice",
	message: "",
	confirmButtonText: "Send",
	loading: false,
	onCancel: () => {},
	onSubmit: () => {},
	billingEmail: ",",
};

export default EmailInvoiceModal;
